// extracted by mini-css-extract-plugin
export default {"root":"cwQ1ek3qbkaYuI9SCw4I"};